(function () {
  'use strict';
  if (window.__adornProductShareV1) return;
  var configElement = document.getElementById('AdornProductShareConfig');
  if (!configElement) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (ignore) { return; }
  window.__adornProductShareV1 = true;
  var dialog, ui, opener, current, controller, generation = 0;
  var cache = { source: '', file: null, objectUrl: '' };
  var icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="m4 17 5-5 4 4 3-3 5 5M12 2v7m-3-4 3-3 3 3"/></svg>';

  function imageUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, location.origin);
      var permitted = url.origin === location.origin || url.hostname === 'cdn.shopify.com';
      if (url.protocol !== 'https:' || !permitted) return '';
      return url.href;
    } catch (ignore) { return ''; }
  }

  function details(section) {
    var info = section.querySelector('product-info[data-url]');
    var url = new URL(info ? info.dataset.url : config.url, location.origin);
    url.search = ''; url.hash = '';
    var variant = section.querySelector('product-form input[name="id"]');
    var id = variant ? variant.value : config.variant;
    if (/^\d+$/.test(String(id))) url.searchParams.set('variant', id);
    var heading = section.querySelector('.product__title h1');
    var active = section.querySelector('.product__media-item.is-active');
    var activeId = active ? active.getAttribute('data-media-id') || '' : '';
    var known = (config.images || []).find(function (item) { return activeId.endsWith('-' + item.id); });
    var img = active && active.querySelector('.product__media img');
    return {
      title: (heading ? heading.textContent.trim() : config.title) || 'Adorn India',
      url: url.href,
      source: imageUrl(known ? known.url : img ? img.currentSrc || img.src : config.image)
    };
  }

  function setStatus(text) { ui.status.textContent = text; }
  function releaseCache() {
    if (cache.objectUrl) URL.revokeObjectURL(cache.objectUrl);
    cache = { source: '', file: null, objectUrl: '' };
  }
  function canShareFile(file) {
    try { return typeof navigator.share === 'function' && typeof navigator.canShare === 'function' && navigator.canShare({ files: [file] }); }
    catch (ignore) { return false; }
  }

  function ready() {
    ui.image.src = cache.objectUrl; ui.image.hidden = false;
    ui.download.href = cache.objectUrl; ui.download.download = cache.file.name; ui.download.hidden = false;
    var supported = canShareFile(cache.file);
    ui.share.disabled = !supported;
    ui.note.textContent = supported
      ? 'Choose WhatsApp or another app from your device share menu. Some apps omit the caption or link; Copy link is also available.'
      : 'This browser cannot attach images through its share menu. Save the image, then attach it in your app and paste the copied product link.';
    setStatus(supported ? 'Photo ready. Tap Share image + link.' : 'Photo ready to save.');
  }

  async function jpegFile(blob, title) {
    if (!/^image\/(jpeg|png|webp|avif|gif)$/i.test(blob.type) || !blob.size || blob.size > 12582912) throw new Error('Invalid image');
    var temporary = URL.createObjectURL(blob), image = new Image();
    try {
      image.src = temporary;
      if (image.decode) await image.decode();
      else await new Promise(function (resolve, reject) { image.onload = resolve; image.onerror = reject; });
      var ratio = Math.min(1, 1200 / Math.max(image.naturalWidth, image.naturalHeight));
      if (!Number.isFinite(ratio) || !image.naturalWidth) throw new Error('Image unavailable');
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * ratio));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * ratio));
      var context = canvas.getContext('2d');
      context.fillStyle = '#ffffff'; context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      var jpeg = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/jpeg', 0.92); });
      canvas.width = 1; canvas.height = 1;
      if (!jpeg) throw new Error('Image conversion unavailable');
      var name = String(title).replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').slice(0, 72) || 'product';
      return new File([jpeg], 'Adorn-India-' + name + '.jpg', { type: 'image/jpeg' });
    } finally { URL.revokeObjectURL(temporary); }
  }

  async function prepare(snapshot, token) {
    if (cache.source === snapshot.source && cache.file) { ready(); return; }
    releaseCache();
    if (!snapshot.source) { setStatus('No product photo is available. You can still copy or share the product link.'); return; }
    var localController = new AbortController(); controller = localController;
    var timer = setTimeout(function () { localController.abort(); }, 15000);
    try {
      var response = await fetch(snapshot.source, { credentials: 'omit', mode: 'cors', signal: localController.signal });
      if (!response.ok) throw new Error('Image unavailable');
      var file = await jpegFile(await response.blob(), snapshot.title);
      if (token !== generation || !dialog.open) return;
      cache = { source: snapshot.source, file: file, objectUrl: URL.createObjectURL(file) };
      ready();
    } catch (error) {
      if (token === generation && dialog.open) setStatus('The photo could not be prepared. You can still copy or share the link; close and reopen to retry the photo.');
    } finally {
      clearTimeout(timer);
      if (controller === localController) controller = null;
    }
  }

  function close() {
    if (!dialog) return;
    generation++;
    if (controller) controller.abort();
    if (dialog.open && typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }

  async function copyLink() {
    try {
      if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(ui.link.value);
      else {
        ui.link.focus(); ui.link.select();
        if (!document.execCommand('copy')) throw new Error('Clipboard unavailable');
      }
      setStatus('Product link copied.');
    } catch (ignore) {
      ui.link.focus(); ui.link.select(); setStatus('Select and copy the product link above.');
    }
  }

  function buildDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'adorn-share-dialog';
    dialog.id = 'AdornProductShareDialog';
    dialog.setAttribute('aria-labelledby', 'AdornProductShareHeading');
    // Static markup only. Product values are assigned with textContent/property setters.
    dialog.innerHTML = '<button type="button" class="adorn-share-close" aria-label="Close product sharing">&times;</button>' +
      '<h2 id="AdornProductShareHeading">Share this product</h2>' +
      '<div class="adorn-share-preview"><img alt="Product photo to share" hidden></div>' +
      '<p class="adorn-share-title"></p>' +
      '<input type="text" readonly aria-label="Product link">' +
      '<div class="adorn-share-actions">' +
      '<button type="button" class="adorn-share-primary" data-share-photo disabled>Share image + link</button>' +
      '<a data-save-photo hidden>Save image</a>' +
      '<button type="button" data-copy-link>Copy link</button>' +
      '<a data-whatsapp-link target="_blank" rel="noopener noreferrer">WhatsApp link</a>' +
      '</div><p class="adorn-share-note"></p><p class="adorn-share-status" role="status" aria-live="polite"></p>';
    document.body.appendChild(dialog);
    ui = {
      image: dialog.querySelector('img'), title: dialog.querySelector('.adorn-share-title'),
      link: dialog.querySelector('input'), share: dialog.querySelector('[data-share-photo]'),
      download: dialog.querySelector('[data-save-photo]'), whatsapp: dialog.querySelector('[data-whatsapp-link]'),
      status: dialog.querySelector('.adorn-share-status'), note: dialog.querySelector('.adorn-share-note')
    };
    dialog.querySelector('.adorn-share-close').addEventListener('click', close);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog.querySelector('[data-copy-link]').addEventListener('click', copyLink);
    ui.share.addEventListener('click', function () {
      if (!current || !cache.file || cache.source !== current.source || !canShareFile(cache.file)) return;
      // File is prepared BEFORE this click. Invoke sharing synchronously to preserve user activation.
      var result, shareGeneration = generation;
      try {
        result = navigator.share({ files: [cache.file], title: current.title, text: current.title, url: current.url });
      } catch (error) { setStatus('Use Save image and Copy link on this device.'); return; }
      ui.share.disabled = true;
      Promise.resolve(result).then(function () {
        if (shareGeneration !== generation) return;
        setStatus('Share request handed to your device.');
      }).catch(function (error) {
        if (shareGeneration !== generation) return;
        setStatus(error && error.name === 'AbortError' ? 'Sharing cancelled. Your photo is still ready.' : 'This app could not accept the photo. Use Save image and Copy link instead.');
      }).finally(function () { if (shareGeneration === generation) ui.share.disabled = !canShareFile(cache.file); });
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), a[href], input')).filter(function (el) { return !el.hidden; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  function open(button, section) {
    buildDialog(); opener = button;
    if (controller) controller.abort();
    var token = ++generation;
    current = details(section);
    ui.title.textContent = current.title;
    ui.image.alt = current.title;
    ui.image.hidden = true; ui.image.removeAttribute('src');
    ui.link.value = current.url;
    ui.download.hidden = true; ui.share.disabled = true;
    ui.whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(current.title + '\n' + current.url);
    ui.note.textContent = 'Preparing the current product photo. No product image is sent until you choose a sharing action.';
    setStatus('Preparing image...');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else { dialog.setAttribute('open', ''); dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true'); }
    dialog.querySelector('.adorn-share-close').focus({ preventScroll: true });
    prepare(current, token);
  }

  function initialize(root) {
    root.querySelectorAll('[id^="MainProduct-"] .product__share-icons').forEach(function (row) {
      if (row.dataset.adornImageShare === 'true') return;
      var section = row.closest('[id^="MainProduct-"]');
      if (!section) return;
      row.dataset.adornImageShare = 'true'; row.classList.add('adorn-share-row');
      var trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'adorn-share-trigger';
      trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-controls', 'AdornProductShareDialog');
      trigger.innerHTML = icon + '<span>Share with photo</span>';
      trigger.addEventListener('click', function () { open(trigger, section); });
      row.insertBefore(trigger, row.firstChild);
      row.querySelectorAll('a[data-share="whatsapp"], a[data-share="facebook"]').forEach(function (link) {
        link.addEventListener('click', function () {
          var product = details(section);
          link.href = link.dataset.share === 'whatsapp'
            ? 'https://wa.me/?text=' + encodeURIComponent(product.title + '\n' + product.url)
            : 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(product.url);
        });
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function () { initialize(document); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (opener && event.target instanceof Element && event.target.contains(opener)) close();
  });
  window.addEventListener('pagehide', function () { close(); releaseCache(); });
})();
